import { PARTNER_FEATURE_FLAGS } from '../../partner-features';
import { MenuItem } from '../types';

/**
 * "Security & Compliance" sidebar section: ryd's network addresses and data-protection facts for
 * every portal user (ticket 2026-10-19-security-and-compliance-section).
 *
 * Fleet-only users (partner type FLEET_PARTNER and nothing else) see it only when the partner's
 * `securityAndComplianceEnabled` flag is on; every other user sees it without the flag. The gate
 * is a sidebar choice, not access control: the routes are open and the AI index serves the
 * content to every partner (D-06).
 *
 * Integration Guide keeps its link to the old `/integration-guide/network-and-security` path (a
 * redirect), so API partners find the page where they always did.
 */
const gate = { fleetOnlyPartnerFeature: PARTNER_FEATURE_FLAGS.SECURITY_AND_COMPLIANCE };

export const securityAndComplianceSection: MenuItem[] = [
  {
    headTitle1: 'Security & Compliance',
    headTitle2: 'How ryd connects and protects data',
    type: 'headtitle',
    ...gate,
  },
  {
    path: '/security-and-compliance/network-and-ip-allowlist',
    title: 'Network & IP Allowlist',
    icon: 'stroke-secure-file',
    iconf: 'fill-secure-file',
    type: 'link',
    active: false,
    ...gate,
  },
  {
    path: '/security-and-compliance/hosting-and-infrastructure',
    title: 'Hosting & Infrastructure',
    icon: 'stroke-widget',
    iconf: 'fill-widget',
    type: 'link',
    active: false,
    ...gate,
  },
  {
    path: '/security-and-compliance/service-providers',
    title: 'Service Providers',
    icon: 'stroke-user',
    iconf: 'fill-user',
    type: 'link',
    active: false,
    ...gate,
  },
  {
    path: '/security-and-compliance/data-protection',
    title: 'Data Protection & GDPR',
    icon: 'stroke-file',
    iconf: 'fill-file',
    type: 'link',
    active: false,
    ...gate,
  },
];
